import {Text} from "@ui-kitten/components";
import * as React from "react";

export const Bold = ({children}) => <Text style={{fontWeight: 'bold'}}>{children}</Text>